<template>
  <CatalogSelect
    :id="id"
    :is-disabled="isDisabled"
    :fetchData="fetchData"
    :searchData="searchData"
    v-on="$listeners"
  >
    <template v-slot:create-catalog="{ refresh }">
      <worker-complaint @refresh="refresh"/>
    </template>
  </CatalogSelect>
</template>

<script>
import catalogs from "../../../network/catalogs";
import CatalogSelect from "../CatalogSelect.vue";
import WorkerComplaint from "./WorkerComplaint";

export default {
  name: "WorkerComplaintSelect",
  components: { CatalogSelect, WorkerComplaint },
  mixins: [ catalogs ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
  },
  methods: {
    async fetchData(id) {
      return await this.getWorkerComplaintById(id);
    },
    async searchData(query) {
      return await this.getWorkerComplaintsSearch(query);
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Catalogs/WorkerComplaints/WorkerComplaintSelect.vue